import { ModuleConfig } from '@/core/module';
import { locationRoutes } from './routes';
import { useLocationStore } from './stores/location-store';
import { useLocationConfigStore } from './stores/location-config-store';

export const LocationModule: ModuleConfig = {
    name: 'location',
    routes: locationRoutes,
    stores: {
        location: useLocationStore,
        locationConfig: useLocationConfigStore
    },
    initialize: () => {
        console.log('Location module initialized');
    }
};

export default LocationModule;
